let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6haI7")).then(() => parcelRequire('3d3w6'));